import React, { Component } from 'react';
import styled from 'styled-components';
import Checkbox from '@zocdoc-frontend-common/components-checkbox';
import ErrorMessage from '@zocdoc-frontend-common/components-errormessage';
import { red80 } from '@zocdoc-mezzanine/foundations-colors';

const INSURANCE_CARD_STRINGS = {
    LinkIceInsuranceCardToApptAndPatient:
        'Share my card with the doctor\n and save for future use.',
    ShareMyCardWithDoctor: 'Share my card with the doctor.',
};

class InsuranceCardSectionView extends Component {
    render() {
        const { imgSrc, showErrorMessage, openImagePreview } = this.props;

        if (imgSrc) {
            let errorMsg = '';

            if (showErrorMessage) {
                errorMsg = (
                    <div>
                        <ErrorMessage data-test="error-message">
                            This doctor requires insurance card information to
                            book.
                        </ErrorMessage>
                    </div>
                );
            }

            return (
                <ShareMyInsuranceCardWrapper>
                    <ShareMyInsuranceCard
                        data-test="share-my-insurance-card"
                        hasError={showErrorMessage}
                    >
                        {this.renderShareMyCardCheckboxText()}

                        <InsuranceCardThumbnailWrapper
                            onClick={openImagePreview}
                            role="button"
                            tabIndex="0"
                        >
                            <img
                                alt="Insurance card thumbnail"
                                className="exclude-from-playback"
                                data-test="insurance-card-thumbnail"
                                src={imgSrc}
                            />
                        </InsuranceCardThumbnailWrapper>
                    </ShareMyInsuranceCard>
                    {errorMsg}
                </ShareMyInsuranceCardWrapper>
            );
        } else {
            return <span data-test="no-insurance-card-to-share" />;
        }
    }

    renderShareMyCardCheckboxText() {
        const {
            hasIceRequestToken,
            isInsuranceCardShared,
            handleShareInsuranceCheckboxChange,
        } = this.props;

        if (hasIceRequestToken) {
            return (
                <Checkbox
                    checked={isInsuranceCardShared}
                    data-test="share-ice-insurance-card"
                    onChecked={handleShareInsuranceCheckboxChange}
                >
                    {
                        INSURANCE_CARD_STRINGS.LinkIceInsuranceCardToApptAndPatient
                    }
                </Checkbox>
            );
        } else {
            return (
                <Checkbox
                    checked={isInsuranceCardShared}
                    data-test="share-insurance-card-without-replace-card-option"
                    onChecked={handleShareInsuranceCheckboxChange}
                >
                    {INSURANCE_CARD_STRINGS.ShareMyCardWithDoctor}
                </Checkbox>
            );
        }
    }
}

export default InsuranceCardSectionView;

const ShareMyInsuranceCard = styled.div`
    border: 1px solid ${(p) => (p.hasError ? red80 : 'transparent')};
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: row-reverse;

    span {
        font-size: 13px;
    }

    label {
        img {
            margin-top: 4px;
        }
    }
`;

const InsuranceCardThumbnailWrapper = styled.div`
    min-width: 100px;
    width: 100px;
    cursor: pointer;
    margin-right: 12px;
`;

export const ShareMyInsuranceCardWrapper = styled.div`
    margin-bottom: 24px;
`;
